import { styled } from '@mui/material'
import { Body2, Stack } from '@collaborate-health/uikit'

// TO DO: remove custom styles during the migration to the shared app styles
export const StyledContentSearchResultContainer = styled(Stack)(({ theme }) => ({
  maxHeight: '180px',
  overflowY: 'auto',
}))

export const StyledSearchContentItemContainer = styled(Stack)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1)} 0`,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const StyledContentDetailsContainer = styled(Stack)(({ theme }) => ({
  maxWidth: '80%',
}))

export const StyledContentDescriptionContainer = styled(Stack)(({ theme }) => ({
  overflow: 'hidden',
}))

export const StyledThumbnail = styled('img')(({ theme }) => ({
  width: '50px',
  height: '50px',
  maxWidth: '50px',
  maxHeight: '50px',
  objectFit: 'cover',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}))

export const StyledDescription = styled(Body2)(({ theme }) => ({
  overflowWrap: 'break-word',
}))

